import { apiService, ApiResponse } from './api';

export interface APIKeyCreateRequest {
  name: string;
  scopes?: string[];
  expires_days?: number | null;
}

export interface APIKeyResponse {
  id: string;
  key?: string | null; // raw only on creation
  name: string;
  scopes: string[];
  user_id: string;
  tenant_id: string;
  created_at: string;
  expires_at?: string | null;
  is_active: boolean;
}

const base = '/auth/v2';

export const authService = {
  async createApiKey(body: APIKeyCreateRequest, bearer?: string): Promise<ApiResponse<APIKeyResponse>> {
    const headers: Record<string, string> | undefined = bearer
      ? { Authorization: `Bearer ${bearer}` }
      : undefined;
    return apiService.post<APIKeyResponse>(`${base}/api-keys`, body, { headers });
  },
};

export default authService;

